import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';

/**
 * Production-ready logging service with performance optimization
 * Automatically disables debug logging in production builds
 */
@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private readonly isProduction = environment.production;
  private readonly logPrefix = '🎤';

  /**
   * Debug logging - automatically disabled in production
   */
  debug(message: string, data?: any): void {
    if (!this.isProduction) {
      if (data) {
        console.log(`${this.logPrefix} ${message}`, data);
      } else {
        console.log(`${this.logPrefix} ${message}`);
      }
    }
  }

  /**
   * Warning logging - always enabled
   */
  warn(message: string, data?: any): void {
    if (data) {
      console.warn(`${this.logPrefix} ${message}`, data);
    } else {
      console.warn(`${this.logPrefix} ${message}`);
    }
  }

  /**
   * Error logging - always enabled
   */
  error(message: string, error?: any): void {
    if (error) {
      console.error(`${this.logPrefix} ${message}`, error);
    } else {
      console.error(`${this.logPrefix} ${message}`);
    }
  }

  /**
   * Info logging - always enabled but minimal
   */
  info(message: string, data?: any): void {
    if (data) {
      console.info(`${this.logPrefix} ${message}`, data);
    } else {
      console.info(`${this.logPrefix} ${message}`);
    }
  }
}
